import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type WittigLocaleCurrencyDTO = z.infer<typeof WittigLocaleCurrencyDTORuntype>;
export const WittigLocaleCurrencyDTORuntype = z.enum(['EUR', 'USD', 'JPY']);

export interface WittigCredentialsDTO extends z.infer<typeof WittigCredentialsDTORuntype> {}
export const WittigCredentialsDTORuntype = z.object({
    api_key: z.string(),
    currency: WittigLocaleCurrencyDTORuntype,
});

export interface WittigCredentialsInputDTO extends z.infer<typeof WittigCredentialsInputDTORuntype> {}
export const WittigCredentialsInputDTORuntype = z.object({
    api_key: z.string().optional(),
    currency: WittigLocaleCurrencyDTORuntype.optional(),
});

export interface WittigResponseBodyDTO extends z.infer<typeof WittigResponseBodyDTORuntype> {}
export const WittigResponseBodyDTORuntype = z.object({
    data: WittigCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
